export enum InternetStatuses {
  OFFLINE = 'offline',
  ONLINE = 'online',
}
